import { Component, Input, input, output } from '@angular/core';
import { DropdownItem } from './dropdown.interface';

@Component({
  selector: 'lib-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  host: { class: 'btn-group' },
})
export class DropdownComponent {
  readonly items = input<DropdownItem[]>([]);

  private _selectedItem?: DropdownItem;
  @Input() set selectedItem(value: DropdownItem | undefined) {
    this.items().forEach((item) => {
      item.isSelected = item === value;
    });
    this._selectedItem = value;
    if (value) {
      this.selected.emit(value);
    }
  }
  get selectedItem(): DropdownItem | undefined {
    return this._selectedItem;
  }

  readonly selected = output<DropdownItem>();

  readonly currentValue = input<string | null>(null);

  get selectedItemName(): string | undefined {
    return this.currentValue() ?? this.selectedItem?.Name;
  }

  onItemSelected(item: DropdownItem): void {
    this.selectedItem = item;
  }
}
